<template>
  <div class="news-detail">
    <div class="detail-container">

      <!-- 文章内容 -->
      <div class="article-content">
        <!-- <div class="item-img">
          <el-image :src="detail.image || require(`@/assets/banner/banner1.png`)" fit="cover" />
        </div> -->
        <div class="content" v-html="detail.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { articleInfo } from '@/api/index'

export default {
  name: 'NewsDetail',
  data() {
    return {
      detail: {}
    }
  },
  created() {
    // 确保页面刷新时也能获取到导航和底部数据
    this.$store.dispatch('getHomeData').then(() => {
      this.getDetail()
    })
  },
  methods: {
    getDetail() {
      const id = this.$route.query.classify_id
      if (!id) {
        this.$message.error('参数错误')
        return
      }
      articleInfo({id: id}).then(res => {
        this.detail = res.data
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.news-detail {
  padding: 20px;
  background-color: #fff;

  .detail-container {
    max-width: 1200px;
    margin: 0 auto;

    .back-btn {
      margin-bottom: 20px;
    }

    .article-content {
      .title {
        font-size: 24px;
        color: #303133;
        margin-bottom: 20px;
        text-align: center;
      }
      .item-img {
        margin-bottom: 20px;
        width: 100%;
      }

      .meta {
        text-align: center;
        color: #909399;
        margin-bottom: 30px;

        :deep(img) {
          max-width: 100%;
          height: auto;
          margin: 10px 0;
        }

        span {
          margin: 0 10px;
        }
      }

      .content {
        line-height: 1.8;
        color: #606266;

        :deep(img) {
          max-width: 100%;
          height: auto;
          margin: 10px 0;
        }

        :deep(p) {
          margin: 16px 0;
        }
      }
    }
  }
}
</style>
